import type { AURA_CONSOLE_EVENTS, AnalyticsTrackPayload, FRAMEWORK_EVENTS, UI_EVENTS } from '@nx/analytics-service';
import { useTrackEvent } from '@nx/state';

export const useTrackUpxEvent = useTrackEvent<
  AnalyticsTrackPayload & { event: AURA_CONSOLE_EVENTS | FRAMEWORK_EVENTS | UI_EVENTS }
>;
